/**
 * Versioned consent for sending Ask Ember questions to the hosted AI path
 * (Quantrolix servers -> Groq, Inc.). Anything other than the current value
 * (missing, corrupt, old version) is no consent. Bump CONSENT_VERSION when the
 * disclosure changes so existing users are asked again.
 */
export const CONSENT_KEY = 'ember_ai_consent';
export const CONSENT_VERSION = 2;
export const CONSENT_VALUE = `granted:v${CONSENT_VERSION}`;

export function hasAiConsent() {
    try {
        return localStorage.getItem(CONSENT_KEY) === CONSENT_VALUE;
    } catch {
        return false;
    }
}

export function grantAiConsent() {
    localStorage.setItem(CONSENT_KEY, CONSENT_VALUE);
}

export function revokeAiConsent() {
    try {
        localStorage.removeItem(CONSENT_KEY);
    } catch { /* nothing stored, nothing to revoke */ }
}

export class AiConsentError extends Error {
    constructor() {
        super('AI consent not granted');
        this.name = 'AiConsentError';
    }
}
